<template>
  <div class="pd-x-10">
    <div>
      <div v-if="demo === false" class="disablePrint level mg-b-0">
        <p class="is-size-5 has-text-weight-semibold">
          {{ $t("form.formHeader") }}
        </p>
      </div>
      <div class="showPrint">
        <div class="border-bt is-flex">
          <div
            v-if="typeof batchData.underLogo !== `undefined`"
            class="borderLogo"
          >
            <img alt="logo name" :src="imgUrlsP + batchData.underLogo" />
          </div>

          <div class="th detailsHeader" style="padding-bottom: 5px">
            <p :title="batchData.name">
              {{ $t("form.formBatchName") }} {{ batchData.name }}
            </p>
            <p :title="batchData.name">
              {{ $t("form.formFiscalYear") }} {{ batchData.fiscalYear }}
            </p>
            <p>
              {{ $t("form.formFiscalUnder") }}
              <span :title="batchData.sciencePark" class="th pd-l-5">{{
                batchData.under
              }}</span>
            </p>
          </div>
        </div>
      </div>
      <div
        v-if="Object.values(formProps).length > 0 && demo === false"
        class="is-size-6 disablePrint"
      >
        <div :title="formProps.name" class="th">{{ formProps.name }}</div>
        <div v-if="getRule === 'startup'" :title="batchData.under" class="th">
          <p>{{ $t("form.formFiscalUnder") }} {{ batchData.under }}</p>
        </div>
      </div>
    </div>

    <transition name="slide-fade">
      <div class="loading-integreat" v-if="isLoadingPage">
        <div class="initial-load-animation">
          <div class="linkedin-image"></div>
          <div class="loading-bar">
            <div class="blue-bar"></div>
          </div>
        </div>
      </div>
    </transition>

    <div
      v-if="tab === true"
      :class="widthMax < 768 ? 'box-t-relative-mobile' : 'box-t-relative'"
      class="m-h-35 disablePrint is-hidden-tablet-only"
    >
      <div class="level disablePrint">
        <div v-if="organizeName === null">
          <p
            v-if="batchData !== null"
            class="has-text-left mg-l-15 has-text-weight-normal is-size-6 th"
            :class="{ 'text-green': widthMax > 768 }"
          >
            {{ $t("form.formBatchName") }}: {{ batchData.name }}
          </p>
        </div>
        <div v-else>
          <p
            v-if="organizeName !== null"
            class="text-green has-text-weight-normal is-size-6 th"
          >
            {{ organizeName }}
          </p>
        </div>
        <div v-if="activeTab === 1" class="is-flex is-align-center">
          <a
            v-if="tabPage === 'list' && getRule !== 'staff'"
            @click="$emit('changPage', null, 'form')"
            class="text-back-page backpage-color has-text-weight-semibold mg-5"
          >
            <i class="fas fa-arrow-left is-margin-right-sm"></i
            >{{ $t("message.btnBackToForm") }}
          </a>
          <a
            v-if="tabPage === 'detail'"
            @click="backToFormList"
            class="text-back-page backpage-color has-text-weight-semibold mg-5"
          >
            <i class="fas fa-arrow-left is-margin-right-sm"></i
            >{{ $t("message.btnBackToFormList") }}
          </a>
          <b-dropdown
            v-if="tabPage === 'list'"
            ref="dropdowntablet"
            position="is-bottom-left"
            class="mg-5"
          >
            <button class="button btn-Filter" slot="trigger">
              <span class="icon is-small">
                <i class="fa fa-filter"></i>
              </span>
              <span>{{ $t("message.btnFilter") }}</span>
            </button>
            <b-dropdown-item custom paddingless>
              <div class="modal-card mx-not modal-search over-filter">
                <section class="modal-card-body">
                  <div class="headerFilter mx-1">
                    <span class="icon is-small is-size-5">
                      <i class="fa fa-filter"></i>
                    </span>
                    <span
                      class="is-padding-sm-x is-size-5 has-text-weight-normal"
                      >{{ $t("message.btnFilter") }}</span
                    >
                  </div>

                  <b-field grouped>
                    <b-input
                      class="is-medium"
                      type="search"
                      icon-pack="fas"
                      v-model="searchCompany"
                      icon="search"
                      :placeholder="$t('form.formDetailColumnCompany')"
                      expanded
                    ></b-input>
                  </b-field>
                  <b-field grouped label>
                    <b-select
                      :placeholder="$t('form.formDetailColumnBusinessType')"
                      v-model="searchIndus"
                      expanded
                    >
                      <option
                        v-for="item in businessType"
                        :key="item.id"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </option>
                    </b-select>
                  </b-field>
                  <b-field grouped label>
                    <b-select
                      :placeholder="$t('form.formDetailColumnStatus')"
                      v-model="searchCompanyStatus"
                      expanded
                    >
                      <option
                        v-for="item in statusAccount"
                        :key="item.statusId"
                        :value="item.statusId"
                      >
                        {{ item.name }}
                      </option>
                    </b-select>
                  </b-field>
                  <b-field grouped>
                    <div class="control is-expanded level">
                      <div class="search-btn">
                        <button @click="filter()" class="button btnSearch">
                          {{ $t("message.btnSearch") }}
                        </button>
                      </div>
                      <div class="reset-btn">
                        <button
                          @click="resetFilter()"
                          class="button btnReset th"
                        >
                          {{ $t("message.btnReset") }}
                        </button>
                      </div>
                    </div>
                  </b-field>
                </section>
              </div>
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div
          v-if="activeTab === 2 || activeTab === 3"
          class="is-flex is-align-center back-filter"
        >
          <a
            v-if="tabPage === 'list' && getRule !== 'staff'"
            @click="$emit('changPage', null, 'form')"
            class="text-back-page backpage-color has-text-weight-semibold mg-5"
          >
            <i class="fas fa-arrow-left is-margin-right-sm"></i
            >{{ $t("message.btnBackToForm") }}
          </a>
        </div>
      </div>
    </div>
    <b-tabs
      v-model="activeTab"
      v-if="tab === true"
      size="is-large"
      id="formListTab"
      :style="widthMax < 768 ? 'margin-top: 6rem;' : ''"
      :class="{
        'tab-mg-t': widthMax < 768,
        'tb-report': activeTab === 2 && tiltleTableFormReport.length !== 0,
      }"
      class="disablePrint tab-not-mg tab-print"
      @change="changTap()"
    >
      <b-tab-item :visible="false"></b-tab-item>

      <b-tab-item
        :label="
          $t('form.formDetailList') +
          ' (' +
          startupList.length +
          '/' +
          allList.length +
          ')'
        "
        class="disablePrint"
      >
        <div v-if="tabPage === 'list'">
          <div class="columns m-h-auto is-vcentered is-hidden-mobile">
            <div
              class="column is-3 has-text-centered"
              @click="sortBy('organizeName')"
            >
              <p
                class="is-size-7 has-text-weight-semibold cr-pointer"
                :class="{
                  'has-text-secondary': currentSort === 'organizeName',
                }"
              >
                {{ $t("form.formDetailColumnCompany") }}
                <span
                  class="arrow"
                  :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
                  v-show="currentSort == 'organizeName'"
                ></span>
              </p>
            </div>
            <div class="column is-2 has-text-centered">
              <p
                class="is-size-7 has-text-weight-semibold cr-pointer"
                @click="sortBy('statusActive')"
              >
                {{ $t("form.formDetailColumnStatus") }}
                <span
                  class="arrow"
                  :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
                  v-show="currentSort == 'statusActive'"
                ></span>
              </p>
            </div>
            <div
              class="column has-text-centered"
              @click="sortBy('typeOfIndustry')"
            >
              <p
                class="is-size-7 has-text-weight-semibold cr-pointer"
                :class="{
                  'has-text-secondary': currentSort === 'typeOfIndustry',
                }"
              >
                {{ $t("form.formDetailColumnBusinessType") }}
                <span
                  class="arrow"
                  :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
                  v-show="currentSort == 'typeOfIndustry'"
                ></span>
              </p>
            </div>
            <div
              v-if="getRule !== 'staff'"
              class="column has-text-centered"
              @click="sortBy('staffId')"
            >
              <p
                class="is-size-7 has-text-weight-semibold cr-pointer"
                :class="{ 'has-text-secondary': currentSort === 'staffId' }"
              >
                {{ $t("form.formDetailColumnStaff") }}
                <span
                  class="arrow"
                  :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
                  v-show="currentSort == 'staffId'"
                ></span>
              </p>
            </div>
            <div class="column has-text-centered">
              <p
                class="is-size-7 has-text-weight-semibold cr-pointer"
                :class="{ 'has-text-secondary': currentSort === 'form' }"
                @click="sortBy('form')"
              >
                {{ $t("form.formDetailFilled") }}
                <span
                  class="arrow"
                  :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
                  v-show="currentSort == 'form'"
                ></span>
              </p>
            </div>
            <div class="column has-text-centered" @click="sortBy('dateUpdate')">
              <p
                class="is-size-7 has-text-weight-semibold cr-pointer"
                :class="{ 'has-text-secondary': currentSort === 'dateUpdate' }"
              >
                {{ $t("form.formDetailRegisterDate") }}
                <span
                  class="arrow"
                  :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
                  v-show="currentSort == 'dateUpdate'"
                ></span>
              </p>
            </div>
            <div class="column is-1"></div>
            <div
              v-if="Object.values(formProps).length > 0"
              class="column is-1"
            ></div>
          </div>
          <FormCompanyList
            :renderCompanyList="renderCompanyList"
            :startupList="startupList"
            :allList="allList"
            :batchData="batchData"
            :activeTab="activeTab"
            :formProps="formProps"
            :getPercenrComplete="getPercenrComplete"
            @goToDetail="goToDetail"
            @setViewComponent="setViewComponent"
            @loadMoreStartupList="loadMoreStartupList"
            @fetchLoading="fetchLoading"
          />
        </div>
        <div v-if="tabPage === 'detail'">
          <div class="columns m-h-auto">
            <div class="column has-text-right">
              <p class="is-size-6">
                <!-- <span class="has-text-weight-normal th mg-r-10">สำเร็จแล้ว: {{percentCompany}}%</span>  -->
                <span class="has-text-weight-semibold"
                  >{{ $t("form.columnLastUpdated") }}:</span
                >
                {{ dateFomat(updateDateForm) }}
              </p>
            </div>
          </div>
          <div class="has-background-white pd-20 is-radius">
            <div class="has-text-right">
              <p>
                <span class="has-text-weight-normal th"
                  >{{ $t("form.number") }}:
                </span>
                <span>{{ getNumberform(formNumber) }}</span>
              </p>
            </div>
            <div class="columns is-marginless">
              <div class="column is-5 box-step pd-5">
                <div>
                  <div class="has-text-left">
                    <aside
                      v-if="renderFormAside === true"
                      class="menu width-max"
                    >
                      <ul
                        class="menu-list ls-none"
                        v-for="(component, index) in forms.components"
                        :key="index"
                      >
                        <li>
                          <b-collapse :aria-id="component.key">
                            <a
                              @click="setFormComponent(component, index)"
                              href="#"
                              v-scroll-to="'#M' + component.key"
                              :class="
                                asideMenu === component.key
                                  ? 'has-text-success-intereat'
                                  : ''
                              "
                              slot="trigger"
                              slot-scope="props"
                              class="th w-break-all is-flex is-align-center is-paddingless"
                              :id="index === 0 ? 'form-select-title' : null"
                              :title="component.componentName"
                            >
                              <span class="d-contents">
                                <b-icon
                                  :class="{
                                    'vs-hidden help':
                                      component.children.length === 0 ||
                                      props.open === true,
                                  }"
                                  pack="fas"
                                  size="is-small"
                                  icon="plus-circle"
                                  class="has-text-grey-light is-size-7"
                                ></b-icon>
                                <b-icon
                                  :class="{
                                    'vs-hidden help':
                                      component.children.length === 0 ||
                                      props.open === false,
                                  }"
                                  pack="fas"
                                  size="is-small"
                                  icon="minus-circle"
                                  class="has-text-grey-light is-size-7"
                                ></b-icon>
                                <span
                                  class="is-size-4 has-text-weight-normal pd-x-5 is-multiline"
                                  >{{
                                    component.componentName | snippetProfileEdit
                                  }}</span
                                >
                                <span
                                  v-if="component.children.length !== 0"
                                  class="pd-x-5 is-size-4"
                                  :class="{
                                    'has-text-success-intereat':
                                      getCompelete(component.key) === true,
                                  }"
                                  >{{ getCompeleteStep(component.children) }}/{{
                                    component.children.length
                                  }}</span
                                >
                                <b-icon
                                  v-if="getCompelete(component.key) === true"
                                  pack="fas"
                                  size="is-small"
                                  icon="check-circle"
                                  class="has-text-success-intereat"
                                ></b-icon>
                              </span>
                            </a>
                            <ul
                              :aria-controls="
                                component.componentName + '' + index
                              "
                              class="is-paddingless"
                            >
                              <FormSubTab
                                :components="component.children"
                                :asideMenu="asideMenu"
                                :getCompelete="getCompelete"
                                :getCompeleteStep="getCompeleteStep"
                                :hiddenCompelete="false"
                                :indexMain="index"
                                @setFormComponent="setFormComponent"
                              />
                            </ul>
                          </b-collapse>
                        </li>
                      </ul>
                    </aside>
                  </div>
                </div>

                <div class="has-text-centered">
                  <a class="box-percent button is-large">
                    <span class="percent"
                      ><span></span
                      >{{
                        isLoadingPage === false
                          ? `${$t("message.labelComplete")}: ${Math.round(
                              (100 / compeleteFormDataAll.length) *
                                compeleteFormData.length
                            )}%`
                          : `${$t("message.msgLoading")}...`
                      }}</span
                    >
                  </a>
                </div>
              </div>
              <div class="column is-7 pd-20 has-text-left">
                <div v-if="isViewComponent">
                  <div class="mg-t-15">
                    <FormInput
                      v-if="renderForm === true"
                      :propsComponentForm="formsChildren"
                      :depth="0"
                      :validPorps="inputValidate"
                      :formType="forms.type"
                      :inputValue="inputValue"
                      :compeleteKey="compeleteKey"
                      :compeleteFormData="compeleteFormData"
                      :formId="forms._id"
                      :checkVarDes="checkVarDes"
                      :checkModelValue="checkModelValue"
                      @setRenderComponent="setRenderComponent"
                      @fetchDataForm="fetchDataForm"
                      :setMatchId="setMatchId"
                      :delInput="delInput"
                      :matchId="matchId"
                      :inputFormData="inputFormData"
                      :addInput="addInput"
                      :addForm="addForm"
                      :delForm="delForm"
                      :inputFormComponent="inputFormComponent"
                      :dataKpi="dataKpi"
                      :dataInputKpi="dataInputKpi"
                      :startupId="startupId"
                      :batchId="batchData._id"
                      :demo="demo"
                      formAction="view"
                      :dataFormInputAll="dataFormInputAll"
                    />
                  </div>
                </div>
                <div v-else>
                  <div class="mg-t-15">
                    <FormInput
                      v-if="renderForm === true"
                      :propsComponentForm="formsChildren"
                      :depth="0"
                      :validPorps="inputValidate"
                      :formType="forms.type"
                      :inputValue="inputValue"
                      :compeleteKey="compeleteKey"
                      :compeleteFormData="compeleteFormData"
                      :formId="forms._id"
                      :checkVarDes="checkVarDes"
                      :checkModelValue="checkModelValue"
                      @setRenderComponent="setRenderComponent"
                      @fetchDataForm="fetchDataForm"
                      :setMatchId="setMatchId"
                      :delInput="delInput"
                      :matchId="matchId"
                      :inputFormData="inputFormData"
                      :addInput="addInput"
                      :addForm="addForm"
                      :delForm="delForm"
                      :inputFormComponent="inputFormComponent"
                      :dataKpi="dataKpi"
                      :dataInputKpi="dataInputKpi"
                      :startupId="startupId"
                      :batchId="batchData._id"
                      :demo="demo"
                      formAction="edit"
                      :dataFormInputAll="dataFormInputAll"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-tab-item>
      <b-tab-item :visible="true" :label="$t('form.formDetailReport')">
        <FormReport
          v-if="randerCumponentReport === true"
          :tableDataValue="dataFormTableAll"
          :tiltleTableFormReport="tiltleTableFormReport"
          :inputFormComponent="inputFormComponent"
        />
      </b-tab-item>
      <b-tab-item :label="$t('form.formDetailSummary')">
        <div
          v-if="
            startupList == '' ||
            startupList == null ||
            Object.values(formProps).length === 0
          "
          class="is-detail-list detail-table mg-y-15"
        >
          <p
            class="has-text-drak is-size-4 th column is-padding-x-s is-margin-top-s has-text-centered"
          ></p>
          <p
            class="has-text-drak is-size-6 th column is-padding-x has-text-centered has-text-centered"
          >
            *** {{ $t("form.notFoundFormData") }} ***
          </p>
          <p
            class="has-text-drak is-size-4 th column is-padding-x-s is-margin-top-s has-text-centered"
          ></p>
        </div>
        <div v-else class="has-background-white pd-20 is-radius">
          <div class="columns is-marginless">
            <div class="column is-5 box-step pd-5">
              <div>
                <div class="has-text-left">
                  <aside v-if="renderFormAside === true" class="menu width-max">
                    <ul
                      class="menu-list ls-none"
                      v-for="(component, index) in forms.components"
                      :key="index"
                    >
                      <li>
                        <b-collapse :aria-id="component.key">
                          <a
                            @click="setFormComponent(component, index)"
                            href="#"
                            v-scroll-to="'#M' + component.key"
                            :class="
                              asideMenu === component.key
                                ? 'has-text-success-intereat'
                                : ''
                            "
                            slot="trigger"
                            slot-scope="props"
                            class="th w-break-all is-flex is-align-center is-paddingless"
                            :title="component.componentName"
                          >
                            <span class="d-contents">
                              <b-icon
                                :class="{
                                  'vs-hidden help':
                                    component.children.length === 0 ||
                                    props.open === true,
                                }"
                                pack="fas"
                                size="is-small"
                                icon="plus-circle"
                                class="has-text-grey-light is-size-7"
                              ></b-icon>
                              <b-icon
                                :class="{
                                  'vs-hidden help':
                                    component.children.length === 0 ||
                                    props.open === false,
                                }"
                                pack="fas"
                                size="is-small"
                                icon="minus-circle"
                                class="has-text-grey-light is-size-7"
                              ></b-icon>
                              <span
                                class="is-size-4 has-text-weight-normal pd-x-5 is-multiline"
                                >{{
                                  component.componentName | snippetProfileEdit
                                }}</span
                              >
                            </span>
                          </a>
                          <ul
                            :aria-controls="
                              component.componentName + '' + index
                            "
                            class="is-paddingless"
                          >
                            <FormSubTab
                              :components="component.children"
                              :asideMenu="asideMenu"
                              :getCompelete="getCompelete"
                              :getCompeleteStep="getCompeleteStep"
                              @setFormComponent="setFormComponent"
                              :hiddenCompelete="true"
                              :indexMain="index"
                            />
                          </ul>
                        </b-collapse>
                      </li>
                    </ul>
                  </aside>
                </div>
                <!-- <div class="has-text-centered">
                                    <a class="box-percent button is-large">
                                         <span class="percent"><span></span>{{(isLoadingPage === false)?'เสร็จแล้ว: '+Math.round((100 / compeleteFormDataAll.length)*compeleteFormData.length)+'%':'กำลังโหลด...'}}</span>
                                    </a>
                                </div> -->
              </div>
            </div>
            <div class="column is-7 pd-20 has-text-left">
              <div class="mg-t-15">
                <FormInput
                  v-if="randerCumponentSum === true"
                  :propsComponentForm="formsChildren"
                  :depth="0"
                  :validPorps="inputValidate"
                  :formType="forms.type"
                  :inputValue="inputValue"
                  :compeleteKey="compeleteKey"
                  :compeleteFormData="compeleteFormData"
                  :formId="forms._id"
                  :checkVarDes="checkVarDes"
                  :checkModelValue="checkModelValue"
                  @setRenderComponent="setRenderComponent"
                  @fetchDataForm="fetchDataForm"
                  :setMatchId="setMatchId"
                  :delInput="delInput"
                  :matchId="matchId"
                  :inputFormData="inputFormData"
                  :addInput="addInput"
                  :addForm="addForm"
                  :delForm="delForm"
                  :inputFormComponent="inputFormComponent"
                  :dataKpi="dataKpi"
                  :dataInputKpi="dataInputKpi"
                  :startupId="startupId"
                  :batchId="batchData._id"
                  :demo="demo"
                  formAction="summary"
                  :dataFormInputAll="dataFormInputAll"
                />
              </div>
            </div>
          </div>
        </div>
      </b-tab-item>
    </b-tabs>

    <div v-else class="disablePrint">
      <p v-if="demo === false" class="is-size-6 has-text-right pd-b-15">
        <span class="has-text-weight-semibold"
          >{{ $t("form.columnLastUpdated") }}:</span
        >
        {{ dateFomat(updateDateForm) }}
      </p>
      <div class="has-background-white pd-20 is-radius">
        <div v-if="demo === false" class="has-text-right">
          <p>
            <span class="has-text-weight-normal th"
              >{{ $t("form.number") }}:
            </span>
            <span>{{ getNumberform(formNumber) }}</span>
          </p>
        </div>
        <div class="columns is-marginless">
          <div class="column is-5 box-step pd-5">
            <div>
              <div class="has-text-left">
                <aside
                  v-if="renderFormAside === true"
                  class="menu width-max"
                  id="form-title"
                >
                  <ul
                    class="menu-list ls-none"
                    v-for="(component, index) in forms.components"
                    :key="index"
                  >
                    <li>
                      <b-collapse :aria-id="component.key">
                        <a
                          @click="setFormComponent(component, index)"
                          href="#"
                          v-scroll-to="'#M' + component.key"
                          :class="
                            asideMenu === component.key
                              ? 'has-text-success-intereat'
                              : ''
                          "
                          slot="trigger"
                          slot-scope="props"
                          class="th w-break-all is-flex is-align-center is-paddingless"
                          :id="index === 0 ? 'form-select-title' : null"
                          :title="component.componentName"
                        >
                          <span class="d-contents">
                            <b-icon
                              :class="{
                                'vs-hidden help':
                                  component.children.length === 0 ||
                                  props.open === true,
                              }"
                              pack="fas"
                              size="is-small"
                              icon="plus-circle"
                              class="has-text-grey-light is-size-7"
                            ></b-icon>
                            <b-icon
                              :class="{
                                'vs-hidden help':
                                  component.children.length === 0 ||
                                  props.open === false,
                              }"
                              pack="fas"
                              size="is-small"
                              icon="minus-circle"
                              class="has-text-grey-light is-size-7"
                            ></b-icon>
                            <span
                              class="is-size-4 has-text-weight-normal pd-x-5 is-multiline"
                              >{{
                                component.componentName | snippetProfileEdit
                              }}</span
                            >
                            <span
                              v-if="
                                component.children.length !== 0 &&
                                demo === false
                              "
                              class="pd-x-5 is-size-4"
                              :class="{
                                'has-text-success-intereat':
                                  getCompelete(component.key) === true,
                              }"
                              >{{ getCompeleteStep(component.children) }}/{{
                                component.children.length
                              }}</span
                            >
                            <b-icon
                              v-if="getCompelete(component.key) === true"
                              pack="fas"
                              size="is-small"
                              icon="check-circle"
                              class="has-text-success-intereat"
                            ></b-icon>
                          </span>
                        </a>
                        <ul
                          :aria-controls="component.componentName + '' + index"
                          class="is-paddingless"
                          :key="index"
                        >
                          <FormSubTab
                            :components="component.children"
                            :asideMenu="asideMenu"
                            :getCompelete="getCompelete"
                            :getCompeleteStep="getCompeleteStep"
                            :hiddenCompelete="demo === true ? true : false"
                            @setFormComponent="setFormComponent"
                            :indexMain="index"
                          />
                        </ul>
                      </b-collapse>
                    </li>
                  </ul>
                </aside>
              </div>
              <div v-if="demo === false" class="has-text-centered">
                <a class="box-percent button is-large" id="form-percent">
                  <span class="percent"
                    ><span></span
                    >{{
                      isLoadingPage === false
                        ? "เสร็จแล้ว: " +
                          Math.round(
                            (100 / compeleteFormDataAll.length) *
                              compeleteFormData.length
                          ) +
                          "%"
                        : "กำลังโหลด..."
                    }}</span
                  >
                </a>
              </div>
            </div>
          </div>
          <div class="column is-7 pd-20 has-text-left">
            <div v-if="isLockForm === true">
              <FormInput
                v-if="renderForm === true"
                :propsComponentForm="formsChildren"
                :depth="0"
                :validPorps="inputValidate"
                :formType="forms.type"
                :inputValue="inputValue"
                :compeleteKey="compeleteKey"
                :compeleteFormData="compeleteFormData"
                :formId="forms._id"
                :checkVarDes="checkVarDes"
                :checkModelValue="checkModelValue"
                @setRenderComponent="setRenderComponent"
                @fetchDataForm="fetchDataForm"
                :setMatchId="setMatchId"
                :delInput="delInput"
                :matchId="matchId"
                :inputFormData="inputFormData"
                :addInput="addInput"
                :addForm="addForm"
                :delForm="delForm"
                :inputFormComponent="inputFormComponent"
                :dataKpi="dataKpi"
                :dataInputKpi="dataInputKpi"
                :startupId="startupId"
                :batchId="batchData._id"
                :demo="demo"
                formAction="view"
                :dataFormInputAll="dataFormInputAll"
              />
            </div>
            <div v-else>
              <div class="mg-t-15" id="form-fill-input">
                <FormInput
                  v-if="renderForm === true"
                  :propsComponentForm="formsChildren"
                  :depth="0"
                  :validPorps="inputValidate"
                  :formType="forms.type"
                  :inputValue="inputValue"
                  :compeleteKey="compeleteKey"
                  :compeleteFormData="compeleteFormData"
                  :formId="forms._id"
                  :checkVarDes="checkVarDes"
                  :checkModelValue="checkModelValue"
                  @setRenderComponent="setRenderComponent"
                  @fetchDataForm="fetchDataForm"
                  :setMatchId="setMatchId"
                  :delInput="delInput"
                  :matchId="matchId"
                  :inputFormData="inputFormData"
                  :addInput="addInput"
                  :addForm="addForm"
                  :delForm="delForm"
                  :inputFormComponent="inputFormComponent"
                  :dataKpi="dataKpi"
                  :dataInputKpi="dataInputKpi"
                  :startupId="startupId"
                  :batchId="batchData._id"
                  :demo="demo"
                  formAction="edit"
                  :dataFormInputAll="dataFormInputAll"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="showPrint">
      <div>
        <div
          v-if="Object.values(formProps).length > 0"
          class="is-size-6 centeralignment"
        >
          <div :title="formProps.name" class="th">{{ formProps.name }}</div>
        </div>
        <div class="flexMg">
          <div class="flexDate">
            <p class="pd-y-5">
              <span class="has-text-weight-normal th"
                >{{ $t("form.number") }}:
              </span>
              <span>{{ getNumberform(formNumber) }}</span>
            </p>
            <p class="pd-y-5">
              <span class="has-text-weight-normal th"
                >{{ $t("form.columnLastUpdated") }}:
              </span>
              <span>{{ dateFomatPrint(updateDateForm) }}</span>
            </p>
          </div>

          <div
            v-if="organizeLogo != null || typeof organizeLogo == 'undefined'"
            class="borderPhoto has-text-centered"
          >
            <span class="th"
              ><img alt="logo name" :src="imgUrl + organizeLogo"
            /></span>
          </div>
          <div v-else class="borderPhoto1 has-text-centered">
            {{ $t("form.desPhoto") }}
          </div>
        </div>
      </div>
      <div class="has-background-white pd-20 is-radius">
        <FormPrint
          v-if="renderForm === true"
          :propsComponentForm="forms.components"
          :depth="0"
          :inputValue="inputValue"
          :inputFormComponent="inputFormComponent"
        />
      </div>
    </div>
    <a
      v-if="printIcon && isViewComponent"
      class="printPage disablePrint cr-pointer"
      @click="onPrint()"
    >
      <i class="fas fa-print"></i>
    </a>
  </div>
</template>

<script>
import { HTTP, HTTPDynamic } from "@/axios.js";
import { covertInputData, getCompleteOld } from "@/service/dynamic";
import momentTH from "moment/src/locale/th";
import moment from "moment";
import FormSubTab from "./FormSubTab";
import FormInput from "./FormInput";
import FormCompanyList from "./FormCompanyList";
import FormSummaryData from "./FormSummaryData";
import FormReport from "./FormReport";
import FormPrint from "./FormPrint";

export default {
  props: [
    "formProps",
    "startupIdProps",
    "batchData",
    "tab",
    "isLockForm",
    "demo",
  ],
  components: {
    FormSubTab,
    FormInput,
    FormCompanyList,
    FormSummaryData,
    FormReport,
    FormPrint,
  },
  data() {
    return {
      widthMax: window.innerWidth,
      forms: [],
      isLoadingPage: false,
      renderForm: false,
      renderFormAside: false,
      stepIndex: 0,
      formsChildren: [],
      dataFormInput: {},
      inputValue: {},
      dataInputKpi: {},
      inputValidate: {},
      checkModelValue: {},
      checkVarDes: {},
      dataKpi: {},
      updateDateForm: null,
      asideMenu: null,
      compeleteKey: [],
      compeleteFormDataAll: [],
      compeleteFormData: [],
      matchId: {},
      matchIdDel: [],
      inputFormData: {},
      dataFormInputAdd: {},
      inputFormComponent: {},
      dataFormComponent: {},
      checkOldCompelete: [],
      activeTab: 1,
      tiltleTableFormReport: [],
      tabPage: "list",
      isViewComponent: false,
      organizeName: null,
      allList: [],
      currentSort: "",
      currentSortDir: "desc",
      searchCompany: null,
      searchIndus: null,
      searchCompanyStatus: null,
      searchLastUpdated: null,
      percentCompleteForm: {},
      renderCompanyList: false,
      percentCompany: 0,
      formNumber: null,
      printIcon: false,
      organizeLogo: null,
      imgUrl: process.env.VUE_APP_IMAGE_URL,
      imgUrlsP: process.env.VUE_APP_IMAGE_URL_sciencePark,
      limitStartUp: 10,
      randerCumponentSum: false,
      randerCumponentReport: false,
      componentIDTmp: [],
      startupId: null,
      indexTabKey: 0,
      dataFormInputAll: [],
      dataFormTableAll: [],
      timeFormRenderCount: 0,
      timeFormRenderAll: 0,
      timeCheckStart: false,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    tokenForm() {
      return this.$store.state.tokenForm;
    },
    statusAccount() {
      return this.$store.state.statusAccount;
    },
    getRule() {
      return this.$store.getters.getRule;
    },
    user() {
      return this.$store.state.user;
    },
    startupList() {
      let startup = [];
      if (
        typeof this.$store.getters.startupLists === "undefined" ||
        this.$store.getters.startupLists === null ||
        this.$store.getters.startupLists.length === 0
      ) {
        startup = [];
      } else {
        startup = this.$store.getters.startupLists.sort((a, b) => {
          let modifier = 1;
          if (this.currentSortDir === "desc") modifier = -1;
          if (this.currentSort === "staffId") {
            if (this.staffName(a.staffId) < this.staffName(b.staffId)) {
              return -1 * modifier;
            }
            if (this.staffName(a.staffId) > this.staffName(b.staffId)) {
              return 1 * modifier;
            }
          } else if (this.currentSort === "typeOfIndustry") {
            if (
              this.getTypeOfIndustry(a.typeOfBusiness) <
              this.getTypeOfIndustry(b.typeOfBusiness)
            ) {
              return -1 * modifier;
            }
            if (
              this.getTypeOfIndustry(a.typeOfBusiness) >
              this.getTypeOfIndustry(b.typeOfBusiness)
            ) {
              return 1 * modifier;
            }
          } else if (this.currentSort === "form") {
            if (
              this.getPercenrComplete(a.startUpId) <
              this.getPercenrComplete(b.startUpId)
            ) {
              return -1 * modifier;
            } else {
              return 1 * modifier;
            }
          } else {
            if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
            if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
          }
          return 0;
        });
      }
      return startup.slice(0, this.limitStartUp);
    },
    businessType() {
      return this.$store.state.businessType;
    },
    getRule() {
      return this.$store.state.rule;
    },
    lastUpdateFormVer() {
      return this.$store.state.lastUpdateFormVer;
    },
  },
  watch: {
    // batchData(){
    //     this.fetchStartupList();
    //     this.fetchstaffList();
    // }
  },
  mounted() {
    this.isLoadingPage = true;
    this.startupId = this.startupIdProps;
    this.fethForm();

    if (Object.values(this.formProps).length > 0) {
      this.setDataSummary();
      this.checkfetchFormname();
      if (this.startupId !== null) {
        this.printIcon = true;
        this.organizeLogo = this.user.organizeLogo;
      } else {
        this.randerCumponentReport = true;
      }
    }
  },
  methods: {
    changTap() {
      if (Object.values(this.formProps).length > 0) {
        this.formsChildren = [];
        this.formsChildren.push(this.forms.components[0]);
        this.fetchLoading();
      }

      this.tabPage = "list";
      if (Object.values(this.formProps).length > 0) {
        if (this.activeTab === 2 || this.activeTab === 3) {
          this.randerCumponentSum = false;
          this.setDataSummary();
        }
        this.checkfetchFormname();
      } else {
        this.randerCumponentReport = true;
      }

      if (this.activeTab === 1 && this.tabPage === "detail") {
        this.printIcon = true;
      } else {
        this.printIcon = false;
      }
    },
    async checkfetchFormname() {
      this.tiltleTableFormReport = [];
      if (this.formProps.type === "template") {
        this.randerCumponentReport = false;
        let data = {
          components: this.componentIDTmp,
        };
        //console.log('====================================');
        // console.log("api/get/form/name/on/template",this.componentIDTmp);
        //console.log('====================================');
        HTTPDynamic.defaults.headers.common.Authorization = `Bearer ${this.token}`;
        await HTTPDynamic.post(`api/get/form/name/on/template`, data)
          .then((res) => {
            // console.log("api/get/form/name/on/template", res);
            if (res.data.success) {
              this.tiltleTableFormReport.push({
                title: "Company",
                field: "company",
                type: "text",
                visible: true,
              });

              res.data.obj.map((item) => {
                let type = typeof item.type !== "undefined" ? item.type : null;
                this.tiltleTableFormReport.push({
                  title: item.title,
                  field: item.name,
                  type: type,
                  visible: true,
                });
              });
            } else {
              this.isLoadingPage = false;
              this.tiltleTableFormReport = [];
            }
            setTimeout(() => {
              this.randerCumponentReport = true;
            }, 1000);
          })
          .catch((e) => {
            setTimeout(() => {
              this.randerCumponentReport = true;
            }, 1000);
            console.log("api/get/form/name/on/template/error", e);
          });
      } else {
        this.fethFormName();
      }
    },
    async fethFormName() {
      this.randerCumponentReport = false;
      let data = {
        componentId: this.formProps._id,
      };
      // console.log("api/get/form/name/by/component/id",this.formToId)
      HTTPDynamic.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      await HTTPDynamic.post(`api/get/form/name/by/component/id`, data)
        .then((res) => {
          // console.log("api/get/form/name/by/component/id",res)
          if (res.data.success) {
            this.tiltleTableFormReport.push({
              title: "Company",
              field: "company",
              type: "text",
              visible: true,
            });
            res.data.obj.map((item) => {
              let type = typeof item.type !== "undefined" ? item.type : null;
              this.tiltleTableFormReport.push({
                title: item.title,
                field: item.name,
                type: type,
                visible: true,
              });
            });
          } else {
            this.isLoadingPage = false;
            this.tiltleTableFormReport = [];
          }
          setTimeout(() => {
            this.randerCumponentReport = true;
          }, 1000);
        })
        .catch((e) => {
          setTimeout(() => {
            this.randerCumponentReport = true;
          }, 1000);
          console.log("api/get/form/name/by/component/id/error", e);
        });
    },
    async setDataSummary() {
      this.dataFormInputAll = [];
      this.dataFormTableAll = [];
      for (let index = 0; index < this.startupList.length; index++) {
        setTimeout(() => {
          this.fetchDataFormAll(
            this.startupList[index].startUpId,
            this.startupList[index].organizeName
          );
        }, 100 * index);
      }

      setTimeout(() => {
        if (this.activeTab === 3) {
          this.randerCumponentSum = true;
        } else {
          this.randerCumponentSum = false;
        }
      }, 1700);
    },
    async fetchDataFormAll(id, name) {
      let data = {
        componentId: this.forms._id,
        companyId: id,
        roleId: this.batchData._id,
        keyRequest: this.tokenForm,
      };

      let value = {
        companyId: id,
      };

      await HTTPDynamic.post(`get/data/form/prod`, data)
        .then(async (res) => {
          if (res.data.success) {
            let dataInput = {};
            if (
              new Date(res.data.obj.updateDate).getTime() <
              new Date(this.lastUpdateFormVer).getTime()
            ) {
              dataInput = await covertInputData(res.data.obj.data);
            } else {
              dataInput = res.data.obj.data[0].input;
            }

            if (dataInput !== null && Object.values(dataInput).length !== 0) {
              let obj = {
                input: dataInput,
              };
              this.dataFormInputAll.push(obj);
            }

            if (dataInput !== null && Object.values(dataInput).length !== 0) {
              Object.keys(dataInput).forEach((key) => {
                let text = "";
                let array = [];

                if (typeof res.data.obj.data[0].inputForm !== "undefined") {
                  Object.keys(res.data.obj.data[0].inputForm).forEach(
                    (keyForm) => {
                      res.data.obj.data[0].inputForm[keyForm].map(
                        (item, index) => {
                          if (
                            typeof dataInput[keyForm + key + index] !==
                              "undefined" &&
                            dataInput[keyForm + key + index] !== null
                          ) {
                            if (
                              typeof dataInput[keyForm + key + index] ===
                                "string" ||
                              typeof dataInput[keyForm + key + index] ===
                                "number"
                            ) {
                              text +=
                                "/" +
                                dataInput[keyForm + key + index].toString();
                            } else if (
                              typeof dataInput[keyForm + key + index].data !==
                              "undefined"
                            ) {
                              if (
                                dataInput[keyForm + key + index].data
                                  .userValue === true
                              ) {
                                text +=
                                  "/" +
                                  dataInput[
                                    keyForm + key + index
                                  ].des.toString();
                              } else {
                                text +=
                                  "/" +
                                  dataInput[
                                    keyForm + key + index
                                  ].data.label.toString();
                              }
                            } else if (
                              dataInput[keyForm + key + index].length !== 0
                            ) {
                              if (
                                typeof dataInput[keyForm + key + index]
                                  .length !== "undefined" &&
                                typeof dataInput[keyForm + key + index] ===
                                  "object"
                              ) {
                                dataInput[keyForm + key + index].map((arr) => {
                                  array.push(arr);
                                });
                              } else {
                                array.push(dataInput[keyForm + key + index]);
                              }
                            }
                          }
                        }
                      );
                    }
                  );
                }

                if (
                  (text !== "" &&
                    dataInput[key] !== null &&
                    typeof dataInput[key] === "string") ||
                  typeof dataInput[key] === "number"
                ) {
                  value[key] = dataInput[key] + text;
                } else if (
                  text !== "" &&
                  dataInput[key] !== null &&
                  typeof dataInput[key].data !== "undefined"
                ) {
                  value[key] = dataInput[key] + text;
                } else if (
                  dataInput[key] !== null &&
                  typeof dataInput[key].length !== "undefined" &&
                  dataInput[key].length !== 0 &&
                  array.length !== 0
                ) {
                  let dataArr = [];
                  dataInput[key].map((item) => {
                    dataArr.push(item);
                  });
                  array.map((item) => {
                    dataArr.push(item);
                  });

                  value[key] = dataArr;
                } else {
                  value[key] = dataInput[key];
                }
              });
            }

            value["company"] = name;

            this.dataFormTableAll.push(value);
            this.dataFormInputAdd =
              typeof res.data.obj.data[0].inputAdd !== "undefined"
                ? res.data.obj.data[0].inputAdd
                : {};
            this.dataFormComponent =
              typeof res.data.obj.data[0].inputForm !== "undefined"
                ? res.data.obj.data[0].inputForm
                : {};

            this.setValueForm(this.forms.components);
          } else {
            value["company"] = name;
            this.dataFormTableAll.push(value);
            this.dataFormInputAdd = {};
            this.dataFormComponent = {};

            this.setValueForm(this.forms.components);
          }
        })
        .catch((e) => {
          console.log("get/data/form/prod/data/all/error", e);
        });
    },
    loadMoreStartupList() {
      this.limitStartUp = this.limitStartUp + 10;
    },
    onPrint() {
      window.print();
    },
    sortBy(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
      }
      this.currentSort = s;
    },
    getTypeOfIndustry(id) {
      const filter = this.businessType.filter((item) => item.id === id);
      let data = [];
      if (
        filter.length === 0 ||
        typeof filter[0].name === "undefined" ||
        filter[0].name === null ||
        filter[0].name === ""
      ) {
        data = "-";
      } else {
        data = filter[0].name;
      }
      return data;
    },
    getPercenrComplete(id) {
      let compelete = this.percentCompleteForm[id];
      if (typeof compelete !== "undefined") {
        let percent = Math.round(
          (100 / this.compeleteFormDataAll.length) * compelete.length
        );
        if (isFinite(percent) === true) {
          return percent;
        } else {
          return 0;
        }
      } else {
        return 0;
      }
    },
    async fetchPercenrComplete() {
      this.renderCompanyList = false;
      this.percentCompleteForm = {};
      for (let index in this.allList) {
        let data = {
          componentId: this.forms._id,
          companyId: this.allList[index].startUpId,
          roleId: this.batchData._id,
          keyRequest: this.tokenForm,
        };

        await HTTPDynamic.post(`get/data/form/prod`, data)
          .then(async (res) => {
            // console.log("get/data/form/prod/percent", res);
            if (res.data.success) {
              if (
                new Date(res.data.obj.updateDate).getTime() <
                new Date(this.lastUpdateFormVer).getTime()
              ) {
                //console.log("await getCompleteOld(this.forms.components,res.data.obj.data)",await getCompleteOld(this.forms.components,res.data.obj.data))
                this.percentCompleteForm[this.allList[index].startUpId] =
                  await getCompleteOld(
                    this.forms.components,
                    res.data.obj.data
                  );
              } else {
                this.percentCompleteForm[this.allList[index].startUpId] =
                  res.data.obj.data[0].complete;
              }
            } else {
              this.percentCompleteForm[this.allList[index].startUpId] = [];
            }
          })
          .catch((e) => {
            console.log("get/data/form/prod/percent/error", e);
          });
      }
      setTimeout(() => {
        this.renderCompanyList = true;
      }, 1000);
    },
    async fetchstaffList() {
      //console.log("this.batchData",this.batchData)
      if (this.batchData !== null) {
        HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
        await HTTP.get(`api/user/get/staff/on/batch/${this.batchData._id}`)
          .then((res) => {
            // console.log("api/user/get/staff/on/batch/${this.batchData._id}",res)
            if (res.data.success) {
              this.staffList = res.data.obj.staffs;
            } else {
              this.staffList = [];
            }
          })
          .catch((e) => {
            console.log(
              "api/user/get/staff/on/batch/${this.batchData._id}/error",
              e
            );
            alert("เครือขายไม่เสถียร กรุณาลองใหม่");
          });
      }
    },
    async fetchStartupList() {
      if (this.batchData !== null) {
        const data = {
          batchId: this.batchData._id,
          token: this.token,
          staffId: this.user._id,
        };

        if (this.getRule == "admin") {
          await this.$store.dispatch("setStartuplist", data);
        } else {
          await this.$store.dispatch("setStartupOnStaff", data);
        }

        this.allList = this.$store.getters.startupLists;
        if (Object.values(this.formProps).length > 0) {
          this.fetchPercenrComplete();
        } else {
          this.renderCompanyList = true;
        }
      }
    },
    async fethForm() {
      this.timeFormRenderCount = 0;
      this.timeFormRenderAll = 0;
      this.timeCheckStart = false;

      if (this.formProps.type === "component") {
        this.forms = {
          _id: this.formProps._id,
          type: this.formProps.type,
          name: this.formProps.name,
          components: this.formProps.components,
        };

        if (Object.values(this.forms).length > 0) {
          this.asideMenu =
            this.forms.components.length > 0
              ? this.forms.components[0].key
              : null;
          this.formsChildren.push(this.forms.components[0]);
        }

        this.fetchLoading();
        this.isLoadingPage = false;
      } else {
        if (Object.values(this.formProps).length !== 0) {
          this.forms = {
            _id: this.formProps._id,
            type: this.formProps.type,
            name: this.formProps.name,
            components: [],
          };
          this.timeFormRenderAll =
            this.timeFormRenderAll + this.formProps.components.length;

          for (
            let index = 0;
            index < this.formProps.components.length;
            index++
          ) {
            setTimeout(() => {
              this.componentIDTmp.push(
                this.formProps.components[index].componentId
              );
              this.getComponent(
                this.formProps.components[index].componentId,
                this.forms.components
              ).then(() => {
                this.fetchComponentChildren(
                  this.formProps.components[index].children,
                  this.forms.components[index]
                );
              });
            }, 500 * index);
          }
        } else {
          this.fetchLoading();
          this.isLoadingPage = false;
        }
      }

      this.renderFormAside = true;
    },
    async fetchLoading() {
      this.isLoadingPage = true;
      this.compeleteKey = [];
      this.compeleteFormDataAll = [];
      await this.fetchDataForm();
      await this.fetchStartupList();
      await this.fetchstaffList();

      setTimeout(() => {
        this.isLoadingPage = false;
      }, 1000);
    },
    setCompleteMenuMain(index) {
      if (
        Object.values(this.formProps).length > 0 &&
        this.forms.components[index].componentData.length === 0
      ) {
        this.compeleteKey.push(this.forms.components[index].key);
      }

      return true;
    },
    async getComponent(id, form) {
      let data = {
        keyRequest: this.tokenForm,
        componentId: id,
      };

      // console.log("api/get/component/by/prod",data);

      await HTTPDynamic.post(`api/get/component/by/prod`, data)
        .then((res) => {
          // console.log("api/get/component/by/prod/res",res);
          if (res.data.success) {
            if (typeof res.data.obj.components !== "undefined") {
              for (
                let index = 0;
                index < res.data.obj.components.length;
                index++
              ) {
                form.push(res.data.obj.components[index]);
              }
            }
            this.timeFormRenderCount = this.timeFormRenderCount + 1;

            if (
              this.timeFormRenderCount === this.timeFormRenderAll &&
              this.timeCheckStart
            ) {
              if (Object.values(this.forms).length > 0) {
                this.asideMenu =
                  this.forms.components.length > 0
                    ? this.forms.components[0].key
                    : null;
                this.formsChildren.push(this.forms.components[0]);
              }

              this.fetchLoading();
              this.isLoadingPage = false;
            }
          } else {
            this.form = [];
          }

          return true;
        })
        .catch((e) => {
          console.log("get/component/by/id/prod/error", e);
        });
    },
    async fetchComponentChildren(component, form) {
      let res = null;
      this.timeCheckStart = true;
      if (component.length > 0) {
        this.timeFormRenderAll = this.timeFormRenderAll + component.length;

        for (let index = 0; index < component.length; index++) {
          setTimeout(() => {
            if (typeof form !== "undefined") {
              this.componentIDTmp.push(component[index].componentId);
              this.getComponent(component[index].componentId, form.children);
            }

            res = form;
            if (component[index].length > 0) {
              this.fetchComponentChildren(component[index].children, res);
            }
          }, 500 * index);
        }
      }
      return true;
    },
    getNumberform(number) {
      let beforeFormNumber = "";
      if (number > 9) {
        beforeFormNumber = "00";
      } else if (this.formNumber > 99) {
        beforeFormNumber = "0";
      } else if (this.formNumber > 999) {
        beforeFormNumber = null;
      } else if (this.formNumber < 10) {
        beforeFormNumber = "000";
      }

      return beforeFormNumber + "" + number;
    },
    async fetchDataForm() {
      this.renderForm = false;
      this.isLoadingPage = true;
      this.fetchDataKpi();
      this.inputValue = {};
      this.inputValidate = {};
      this.compeleteKey = [];
      this.compeleteFormDataAll = [];

      if (typeof this.indexTabKey !== "undefined") {
        await this.setCompleteMenuMain(this.indexTabKey);
      }
      let data = {
        componentId: this.forms._id,
        companyId: this.startupId,
        roleId: this.batchData._id,
        keyRequest: this.tokenForm,
      };

      await HTTPDynamic.post(`get/data/form/prod`, data)
        .then(async (res) => {
          if (res.data.success) {
            if (
              new Date(res.data.obj.updateDate).getTime() <
              new Date(this.lastUpdateFormVer).getTime()
            ) {
              this.dataFormInput = covertInputData(res.data.obj.data);
              this.compeleteFormData = await getCompleteOld(
                this.forms.components,
                res.data.obj.data
              );
            } else {
              this.dataFormInput = res.data.obj.data[0].input;
              this.compeleteFormData = res.data.obj.data[0].complete;
            }
            this.updateDateForm = res.data.obj.updateDate;
            this.dataFormInputAdd =
              typeof res.data.obj.data[0].inputAdd !== "undefined"
                ? res.data.obj.data[0].inputAdd
                : {};
            this.dataFormComponent =
              typeof res.data.obj.data[0].inputForm !== "undefined"
                ? res.data.obj.data[0].inputForm
                : {};

            if (Object.values(this.forms).length > 0) {
              await this.setValidForm(this.formsChildren);
              await this.setValueForm(this.forms.components);
            }

            setTimeout(() => {
              this.renderForm = true;
              this.isLoadingPage = false;
            }, 2000);
          } else {
            this.dataFormInput = {};
            this.dataFormInputAdd = {};
            this.dataFormComponent = {};
            this.compeleteFormData = [];
            this.updateDateForm = null;
            if (Object.values(this.forms).length > 0) {
              await this.setValidForm(this.formsChildren);
              await this.setValueForm(this.forms.components);
            }
            setTimeout(() => {
              this.renderForm = true;
              this.isLoadingPage = false;
            }, 2000);
          }

          this.formNumber =
            res.data.obj !== null &&
            typeof res.data.obj.appNumber !== "undefined"
              ? res.data.obj.appNumber
              : "-";
        })
        .catch((e) => {
          console.log("get/data/form/prod/error", e);
        });
    },
    async fetchDataKpi() {
      let data = {
        companyId: this.startupId,
        roleId: this.batchData._id,
      };

      HTTPDynamic.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      await HTTPDynamic.post("api/get/kpi", data)
        .then((res) => {
          // console.log("api/get/kpi", res,data);
          if (res.data.success) {
            this.dataKpi = res.data.obj.kpi;
          } else {
            this.dataKpi = {};
          }
        })
        .catch((e) => {
          console.log("api/get/kpi/error", e);
        });
    },
    async setValueForm(components) {
      let value = [];

      await components.map(async (component) => {
        this.compeleteFormDataAll.push(component.key);

        if (typeof this.dataFormComponent[component.key] !== "undefined") {
          this.inputFormComponent[component.key] = [];

          for (let index in this.dataFormComponent[component.key]) {
            this.inputFormComponent[component.key].push(
              this.dataFormComponent[component.key][index]
            );
            for (let indexData in this.dataFormComponent[component.key][index]
              .componentData) {
              let display = component.componentData[indexData].display;
              let options = component.componentData[indexData].options;
              let data =
                this.dataFormComponent[component.key][index].componentData[
                  indexData
                ];
              data.display = display;
              data.options = options;
              this.setDataInput(this.dataFormInput[data.name], data, component);
              if (
                typeof this.dataFormInputAdd[data.name] !== "undefined" &&
                this.dataFormInputAdd[data.name].length > 0
              ) {
                this.inputFormData[data.name] = [];
                for (let indexAdd in this.dataFormInputAdd[data.name]) {
                  this.dataFormInputAdd[data.name][indexAdd].display = display;
                  this.dataFormInputAdd[data.name][indexAdd].options = options;
                  let name = this.dataFormInputAdd[data.name][indexAdd].name;
                  this.inputFormData[data.name].push(
                    this.dataFormInputAdd[data.name][indexAdd]
                  );
                  this.setDataInput(
                    this.dataFormInput[name],
                    this.dataFormInputAdd[data.name][indexAdd],
                    component
                  );
                }
              }
            }
          }
        }

        await component.componentData.map((item) => {
          this.setDataInput(this.dataFormInput[item.name], item, component);
          if (
            typeof this.dataFormInputAdd[item.name] !== "undefined" &&
            this.dataFormInputAdd[item.name].length > 0
          ) {
            this.inputFormData[item.name] = [];
            for (
              let index = 0;
              index < this.dataFormInputAdd[item.name].length;
              index++
            ) {
              this.dataFormInputAdd[item.name][index].display = item.display;
              this.dataFormInputAdd[item.name][index].options = item.options;
              let name = this.dataFormInputAdd[item.name][index].name;
              this.inputFormData[item.name].push(
                this.dataFormInputAdd[item.name][index]
              );
              this.setDataInput(
                this.dataFormInput[name],
                this.dataFormInputAdd[item.name][index],
                component
              );
            }
          }
        });

        if (component.children.length > 0) {
          await this.setValueForm(component.children);
        }
        return true;
      });
    },
    setDataInput(input, item, component) {
      let inputData = input;
      if (item.type === "checkbox") {
        this.inputValue[item.name] =
          typeof inputData !== "undefined" ? inputData : [];
        if (typeof inputData !== "undefined") {
          this.checkModelValue[item.name] = [];

          for (let index = 0; index < inputData.length; index++) {
            this.checkModelValue[item.name].push({
              label: inputData[index].label,
              value: inputData[index].value,
              userValue: inputData[index].userValue,
              index: inputData[index].index,
            });
          }

          for (let index = 0; index < item.display.value.length; index++) {
            let data = inputData.filter(
              (itemInput) => itemInput.label === item.display.value[index].label
            );
            if (
              typeof item.display.value[index] !== "undefined" &&
              item.display.value[index].userValue === true
            ) {
              if (data.length > 0) {
                this.checkVarDes[item.name + data[0].index] = {
                  index: index,
                  des: data[0].des,
                };
              } else {
                this.checkVarDes[item.name + index] = {
                  index: index,
                  des: null,
                };
              }
            }
            if (
              item.display.value[index].Keyid !== "" &&
              typeof inputData !== "undefined"
            ) {
              if (data.length > 0) {
                this.matchId[item.display.value[index].Keyid] =
                  item.display.value[index].Keyid;
                this.setMatchId(
                  this.checkModelValue[item.name],
                  item.display.value[index],
                  component,
                  "checkbox"
                );
              }
            }
          }
        } else {
          this.checkModelValue[item.name] = [];
          for (let index = 0; index < item.display.value.length; index++) {
            if (
              typeof item.display.value[index].userValue !== "undefined" &&
              item.display.value[index].userValue === true
            ) {
              this.checkVarDes[item.name + index] = { index: index, des: null };
            }

            if (item.display.value[index].Keyid !== "") {
              this.matchId[item.display.value[index].Keyid] = "";
            }
          }
        }
      } else if (item.type === "date") {
        this.inputValue[item.name] =
          typeof inputData !== "undefined" ? inputData : null;
      } else if (item.type === "file") {
        let defaultInput = item.options.multiple === true ? [] : null;
        this.inputValue[item.name] =
          typeof inputData !== "undefined" &&
          inputData !== null &&
          typeof inputData.length !== 0
            ? inputData
            : defaultInput;
      } else if (item.type === "radio") {
        this.inputValue[item.name] =
          typeof inputData !== "undefined"
            ? { data: inputData.data, des: null }
            : { data: null, des: null };
        for (let index = 0; index < item.display.value.length; index++) {
          if (
            typeof inputData !== "undefined" &&
            item.display.value[index].userValue === true
          ) {
            this.inputValue[item.name]["des"] =
              typeof inputData !== "undefined" ? inputData.des : null;
          }

          if (item.display.value[index].Keyid !== "") {
            if (
              typeof inputData !== "undefined" &&
              inputData.data !== null &&
              inputData.data.label === item.display.value[index].label
            ) {
              this.matchId[item.display.value[index].Keyid] =
                item.display.value[index].Keyid;
              this.setMatchId(
                item.display.value,
                item.display.value[index],
                component,
                "checkbox"
              );
            } else {
              this.matchId[item.display.value[index].Keyid] = "";
            }
          }
        }
      } else {
        this.inputValue[item.name] =
          typeof inputData !== "undefined" ? inputData : null;
        if (
          typeof item.options !== "undefined" &&
          typeof item.options.repeat !== "undefined" &&
          item.options.repeat === true
        ) {
          if (typeof this.dataKpi[item.name] !== "undefined") {
            let obj = {
              repeatStart: item.options.repeatStart,
              everyRepeat: item.options.everyRepeat,
              repeatStop: item.options.repeatStop,
            };
            this.dataInputKpi[item.name] = {
              type: item.type,
              input: this.dataKpi[item.name].input,
              lastUpdate: new Date(this.dataKpi[item.name].lastUpdate),
              repeatStop: false,
              repeat: obj,
              nameLabel: item.display.label,
            };

            let count = 1;
            let repeatDate = new Date(item.options.repeatStart);
            let repeatStartNum = repeatDate.getMonth();
            let updateDateForm =
              new Date(this.dataKpi[item.name].lastUpdate).getFullYear() +
              "-" +
              (new Date(this.dataKpi[item.name].lastUpdate).getMonth() + 1) +
              "-" +
              new Date(this.dataKpi[item.name].lastUpdate).getDate();
            // console.log("repeatDate",repeatDate)
            while (repeatDate.getTime() <= new Date().getTime()) {
              // console.log("count",count)
              // console.log("now",new Date('2019-8-28').getTime())
              // console.log("repeatDate1",repeatDate,repeatDate.getTime())
              // console.log("repeatStart.setMonth("+ (repeatStartNum + (item.options.everyRepeat*count))+",1)",new Date(repeatDate))

              if (
                typeof this.dataKpi[item.name].lastUpdate !== "undefined" &&
                new Date().getTime() >= repeatDate.getTime()
              ) {
                if (new Date(updateDateForm).getTime() < repeatDate.getTime()) {
                  this.inputValue[item.name] = null;
                } else {
                  this.inputValue[item.name] =
                    typeof inputData !== "undefined" ? inputData : null;
                }
              }

              repeatDate = new Date(item.options.repeatStart);
              repeatDate.setMonth(
                repeatStartNum + item.options.everyRepeat * count,
                1
              );
              count++;
            }
          } else {
            let obj = {
              repeatStart: item.options.repeatStart,
              everyRepeat: item.options.everyRepeat,
              repeatStop: item.options.repeatStop,
            };
            this.dataInputKpi[item.name] = {
              type: item.type,
              input: "",
              lastUpdate: null,
              repeatStop: true,
              repeat: obj,
              nameLabel: item.display.label,
            };
          }
        }
      }
      return true;
    },
    async setValidForm(components) {
      await components.map(async (component) => {
        let filter = this.compeleteKey.filter(
          (filter) => filter === component.key
        );
        if (filter.length === 0) {
          this.compeleteKey.push(component.key);
        }

        if (typeof this.dataFormComponent[component.key] !== "undefined") {
          for (let index in this.dataFormComponent[component.key]) {
            for (let indexData in this.dataFormComponent[component.key][index]
              .componentData) {
              let validation = component.componentData[indexData].validation;
              let data =
                this.dataFormComponent[component.key][index].componentData[
                  indexData
                ];
              data.validation = validation;
              await this.setValidInput(data);
              if (
                typeof this.dataFormInputAdd[data.name] !== "undefined" &&
                this.dataFormInputAdd[data.name].length > 0
              ) {
                for (let indexAdd in this.dataFormInputAdd[data.name]) {
                  this.dataFormInputAdd[data.name][indexAdd].validation =
                    validation;
                  await this.setValidInput(
                    this.dataFormInputAdd[data.name][indexAdd]
                  );
                }
              }
            }
          }
        }

        await component.componentData.map(async (item) => {
          await this.setValidInput(item);
          if (
            typeof this.dataFormInputAdd[item.name] !== "undefined" &&
            this.dataFormInputAdd[item.name].length > 0
          ) {
            for (
              let index = 0;
              index < this.dataFormInputAdd[item.name].length;
              index++
            ) {
              this.dataFormInputAdd[item.name][index].validation =
                item.validation;
              await this.setValidInput(this.dataFormInputAdd[item.name][index]);
            }
          }
        });

        if (component.children.length > 0) {
          await this.setValidForm(component.children);
        }
      });
      return true;
    },
    setValidInput(item) {
      if (
        typeof item.display.matchid !== "undefined" &&
        item.display.matchid !== ""
      ) {
        this.inputValidate[item.name] = {
          name: item.name,
          validation: item.validation,
          type: item.type,
          valid: false,
          hidden: true,
        };
        if (item.type === "radio") {
          for (let index = 0; index < item.display.value.length; index++) {
            if (
              typeof item.display.value[index].userValue !== "undefined" &&
              item.display.value[index].userValue === true
            ) {
              this.inputValidate[item.name + "UserValue" + index] = {
                name: item.name,
                validation: { errorMsg: "กรุณากรอกข้อความ", required: true },
                type: "radioDes",
                valid: false,
                hidden: true,
              };
            }
          }
        }

        if (item.type === "checkbox") {
          for (let index = 0; index < item.display.value.length; index++) {
            if (
              typeof item.display.value[index].userValue !== "undefined" &&
              item.display.value[index].userValue === true
            ) {
              this.inputValidate[item.name + "UserValue" + index] = {
                name: item.name,
                validation: { errorMsg: "กรุณากรอกข้อความ", required: true },
                type: "checkBoxDes",
                valid: false,
                hidden: true,
              };
            }
          }
        }
      } else {
        this.inputValidate[item.name] = {
          name: item.name,
          validation: item.validation,
          type: item.type,
          valid: false,
          hidden: false,
        };
        if (item.type === "radio") {
          for (let index = 0; index < item.display.value.length; index++) {
            if (
              typeof item.display.value[index].userValue !== "undefined" &&
              item.display.value[index].userValue === true
            ) {
              this.inputValidate[item.name + "UserValue" + index] = {
                name: item.name,
                validation: { errorMsg: "กรุณากรอกข้อความ", required: true },
                type: "radioDes",
                valid: false,
                hidden: false,
              };
            }
          }
        }

        if (item.type === "checkbox") {
          for (let index = 0; index < item.display.value.length; index++) {
            if (
              typeof item.display.value[index].userValue !== "undefined" &&
              item.display.value[index].userValue === true
            ) {
              this.inputValidate[item.name + "UserValue" + index] = {
                name: item.name,
                validation: { errorMsg: "กรุณากรอกข้อความ", required: true },
                type: "checkBoxDes",
                valid: false,
                hidden: false,
              };
            }
          }
        }
      }

      return true;
    },
    async setValueMatch(components, keyId, status) {
      await components.map(async (component) => {
        await component.componentData.map((item) => {
          if (
            typeof item.display.matchid !== "undefined" &&
            typeof item.display.matchid !== ""
          ) {
            // let key = keyId.filter(key=>key === item.display.matchid)
            if (keyId === item.display.matchid) {
              if (status === true) {
                this.inputValidate[item.name] = {
                  name: item.name,
                  validation: item.validation,
                  type: item.type,
                  valid: false,
                  hidden: false,
                };
              } else {
                this.inputValidate[item.name] = {
                  name: item.name,
                  validation: item.validation,
                  type: item.type,
                  valid: false,
                  hidden: true,
                };
              }

              if (item.type === "radio") {
                for (
                  let index = 0;
                  index < item.display.value.length;
                  index++
                ) {
                  if (
                    typeof item.display.value[index].userValue !==
                      "undefined" &&
                    item.display.value[index].userValue === true
                  ) {
                    if (status === true) {
                      this.inputValidate[item.name + "UserValue" + index] = {
                        name: item.name,
                        validation: {
                          errorMsg: "กรุณากรอกข้อความ",
                          required: true,
                        },
                        type: "radioDes",
                        valid: false,
                        hidden: false,
                      };
                    } else {
                      this.inputValidate[item.name + "UserValue" + index] = {
                        name: item.name,
                        validation: {
                          errorMsg: "กรุณากรอกข้อความ",
                          required: true,
                        },
                        type: "radioDes",
                        valid: false,
                        hidden: true,
                      };
                    }
                  }
                }
              }

              if (item.type === "checkbox") {
                for (
                  let index = 0;
                  index < item.display.value.length;
                  index++
                ) {
                  if (
                    typeof item.display.value[index].userValue !==
                      "undefined" &&
                    item.display.value[index].userValue === true
                  ) {
                    if (status === true) {
                      this.inputValidate[item.name + "UserValue" + index] = {
                        name: item.name,
                        validation: {
                          errorMsg: "กรุณากรอกข้อความ",
                          required: true,
                        },
                        type: "checkBoxDes",
                        valid: false,
                        hidden: false,
                      };
                    } else {
                      this.inputValidate[item.name + "UserValue" + index] = {
                        name: item.name,
                        validation: {
                          errorMsg: "กรุณากรอกข้อความ",
                          required: true,
                        },
                        type: "checkBoxDes",
                        valid: false,
                        hidden: true,
                      };
                    }
                  }
                }
              }

              if (item.type === "checkbox") {
                this.inputValue[item.name] = [];
                this.checkModelValue[item.name] = [];
                for (
                  let index = 0;
                  index < item.display.value.length;
                  index++
                ) {
                  if (item.display.value[index].Keyid !== "") {
                    this.matchId[item.display.value[index].Keyid] = "";
                  }
                  if (
                    typeof item.display.value[index].userValue !==
                      "undefined" &&
                    item.display.value[index].userValue === true
                  ) {
                    this.checkVarDes[item.name + index] = {
                      index: index,
                      des: null,
                    };
                  }
                }
              } else if (item.type === "date") {
                this.inputValue[item.name] = null;
              } else if (item.type === "file") {
                this.inputValue[item.name] = [];
              } else if (item.type === "radio") {
                this.inputValue[item.name] = { data: null, des: null };
                for (
                  let index = 0;
                  index < item.display.value.length;
                  index++
                ) {
                  if (item.display.value[index].Keyid !== "") {
                    this.matchId[item.display.value[index].Keyid] = "";
                  }
                }
              } else {
                this.inputValue[item.name] = null;
              }
            }
          }
        });

        if (component.children.length > 0) {
          await this.setValueMatch(component.children, keyId);
        } else {
          //console.log("this.matchId",this.matchId)
          setTimeout(() => {
            this.renderForm = true;
          }, 1);
        }
      });
    },
    async setFormComponent(data, index) {
      this.renderForm = false;
      this.asideMenu = data.key;
      this.inputValidate = {};
      this.formsChildren = [];
      this.formsChildren.push(data);
      this.compeleteKey = [];
      this.compeleteFormDataAll = [];

      this.indexTabKey = index;
      await this.fetchLoading();
    },
    getCompelete(key) {
      let data = this.compeleteFormData.filter((item) => item === key);
      if (data.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    setRenderComponent(status) {
      this.renderForm = status;
      setTimeout(() => {
        if (status === true) {
          this.renderForm = false;
        } else {
          this.renderForm = true;
        }
      }, 1);
    },
    setMatchId(data, value, component, type) {
      //console.log("value.Keyid",value.Keyid)
      if (type === "radio") {
        if (value.Keyid !== "") {
          for (let index in data) {
            if (data[index].Keyid === value.Keyid) {
              this.matchId[data[index].Keyid] = value.Keyid;
              this.renderForm = false;
              this.setValueMatch([component], data[index].Keyid, true);
            } else {
              this.matchId[data[index].Keyid] = "";
              this.renderForm = false;
              this.setValueMatch([component], data[index].Keyid, false);
            }
          }
        }
      } else {
        let res = data.filter((item) => item.label === value.label);

        if (value.Keyid !== "") {
          if (res.length > 0) {
            this.matchId[value.Keyid] = value.Keyid;
            this.renderForm = false;
            this.setValueMatch([component], value.Keyid, true);
          } else {
            this.matchId[value.Keyid] = "";
            this.renderForm = false;
            this.setValueMatch([component], value.Keyid, false);
          }
        }
      }
      //console.log("this.matchId",this.renderForm)
    },
    getCompeleteStep(component) {
      let data = component.filter(
        (item) => this.getCompelete(item.key) === true
      );
      return data.length;
    },
    addInput(input, component) {
      this.renderForm = false;
      let obj = JSON.parse(JSON.stringify(input));

      if (typeof this.inputFormData[input.name] === "undefined") {
        this.inputFormData[input.name] = [];
      }

      let newName = input.name + "" + this.inputFormData[input.name].length;
      obj["name"] = newName;

      this.setDataInput(this.inputValue[newName], obj, component);

      this.setValidInput(obj);
      this.inputFormData[input.name].push(obj);
      setTimeout(() => {
        this.renderForm = true;
      }, 1);
    },
    delInput(name, index) {
      this.renderForm = false;

      let formData = JSON.parse(JSON.stringify(this.inputFormData[name]));
      let arr = [];
      let component = [];

      for (let indexData in formData) {
        if (Number(indexData) !== index) {
          arr.push({
            value: this.inputValue[name + "" + indexData],
            validate: this.inputValidate[name + "" + indexData],
          });
          component.push(this.inputFormData[name][indexData]);
        }
        let item = formData[indexData];
        if (item.type === "radio") {
          for (let index = 0; index < item.display.value.length; index++) {
            if (
              typeof item.display.value[index].userValue !== "undefined" &&
              item.display.value[index].userValue === true
            ) {
              delete this.inputValidate[item.name + "UserValue" + index];
            }
          }
        } else if (item.type === "checkbox") {
          for (let index = 0; index < item.display.value.length; index++) {
            if (
              typeof item.display.value[index].userValue !== "undefined" &&
              item.display.value[index].userValue === true
            ) {
              delete this.inputValidate[item.name + "UserValue" + index];
            }
          }
        }

        delete this.inputValidate[name + "" + indexData];
        delete this.inputValue[name + "" + indexData];
      }
      this.inputFormData[name] = [];
      for (let newIndex in arr) {
        let newName = name + "" + newIndex;
        component[newIndex].name = newName;
        this.setDataInput(arr[newIndex].value, component[newIndex], formData);
        this.setValidInput(component[newIndex]);
        this.inputFormData[name].push(component[newIndex]);
      }

      setTimeout(() => {
        // console.log("this.inputValue",this.inputValue)
        // console.log("this.inputValidate",this.inputValidate)
        this.renderForm = true;
      }, 1);
    },
    addForm(input) {
      this.renderForm = false;

      let obj = JSON.parse(JSON.stringify(input));

      if (typeof this.inputFormComponent[input.key] === "undefined") {
        this.inputFormComponent[input.key] = [];
      }

      for (var i in input.componentData) {
        let newName =
          input.key +
          "" +
          obj.componentData[i].name +
          "" +
          this.inputFormComponent[input.key].length;
        obj.componentData[i].fristName = obj.componentData[i].name;
        obj.componentData[i].name = newName;
        let component = JSON.parse(JSON.stringify(input.componentData[i]));
        component.name = newName;
        this.setDataInput(this.inputValue[newName], component, input);
        this.setValidInput(component);
        // this.inputValue[newName] = null
      }

      this.inputFormComponent[input.key].push(obj);
      setTimeout(() => {
        this.renderForm = true;
      }, 1);
    },
    delForm(name, index) {
      this.renderForm = false;
      let obj = JSON.parse(JSON.stringify(this.inputFormComponent[name]));

      let arr = [];
      let form = [];
      let component = [];

      for (let indexForm in obj) {
        if (Number(indexForm) !== index) {
          let value = [];
          let valid = [];
          for (let indexData in obj[indexForm].componentData) {
            let nameData = obj[indexForm].componentData[indexData].name;
            value.push(this.inputValue[nameData]);
            valid.push(this.inputValidate[nameData]);
            if (typeof this.inputFormData[nameData] !== "undefined") {
              let formData = JSON.parse(
                JSON.stringify(this.inputFormData[nameData])
              );
              let inputData = [];
              let valueArr = [];
              let validArr = [];
              for (let indexDataAdd in formData) {
                inputData.push(formData[indexDataAdd]);
                valueArr.push(this.inputValue[nameData + "" + indexDataAdd]);
                validArr.push(this.inputValidate[nameData + "" + indexDataAdd]);
                arr.push({
                  value: this.inputValue[nameData + "" + indexDataAdd],
                  validate: this.inputValidate[nameData + "" + indexDataAdd],
                });
              }
              component.push({
                name: nameData,
                data: inputData,
                value: valueArr,
                valid: validArr,
              });
            }
          }
          form.push({ obj: obj[indexForm], value: value, valid: valid });
        }

        for (let indexData in obj[indexForm].componentData) {
          let nameData = obj[indexForm].componentData[indexData].name;
          let item = obj[indexForm].componentData[indexData];
          delete this.inputValue[nameData];
          delete this.inputValidate[nameData];
          if (item.type === "radio") {
            for (let index = 0; index < item.display.value.length; index++) {
              if (
                typeof item.display.value[index].userValue !== "undefined" &&
                item.display.value[index].userValue === true
              ) {
                delete this.inputValidate[item.name + "UserValue" + index];
              }
            }
          } else if (item.type === "checkbox") {
            for (let index = 0; index < item.display.value.length; index++) {
              if (
                typeof item.display.value[index].userValue !== "undefined" &&
                item.display.value[index].userValue === true
              ) {
                delete this.inputValidate[item.name + "UserValue" + index];
              }
            }
          }

          if (typeof this.inputFormData[nameData] !== "undefined") {
            let formData = JSON.parse(
              JSON.stringify(this.inputFormData[nameData])
            );
            for (let indexDataAdd in formData) {
              let itemAdd = formData[indexDataAdd];
              delete this.inputValidate[nameData + "" + indexDataAdd];
              delete this.inputValue[nameData + "" + indexDataAdd];
              if (itemAdd.type === "radio") {
                for (
                  let index = 0;
                  index < itemAdd.display.value.length;
                  index++
                ) {
                  if (
                    typeof itemAdd.display.value[index].userValue !==
                      "undefined" &&
                    itemAdd.display.value[index].userValue === true
                  ) {
                    delete this.inputValidate[
                      itemAdd.name + "UserValue" + index
                    ];
                  }
                }
              } else if (itemAdd.type === "checkbox") {
                for (
                  let index = 0;
                  index < itemAdd.display.value.length;
                  index++
                ) {
                  if (
                    typeof itemAdd.display.value[index].userValue !==
                      "undefined" &&
                    itemAdd.display.value[index].userValue === true
                  ) {
                    delete this.inputValidate[
                      itemAdd.name + "UserValue" + index
                    ];
                  }
                }
              }
            }
            delete this.inputFormData[nameData];
          }
        }
      }

      for (let newIndexComponent in component) {
        let componentData = component[newIndexComponent].data;
        let value = component[newIndexComponent].value;
        let valid = component[newIndexComponent].valid;
        let nameFormData =
          componentData.length > 0
            ? name + "" + componentData[0].fristName + "" + newIndexComponent
            : "";
        let data = {};
        this.inputFormData[nameFormData] = [];
        for (let newIndexData in componentData) {
          let nameInput =
            name +
            "" +
            componentData[newIndexData].fristName +
            "" +
            newIndexComponent +
            "" +
            newIndexData;
          componentData[newIndexData].name = nameInput;
          this.inputFormData[nameFormData].push(componentData[newIndexData]);
          this.setDataInput(
            value[newIndexData],
            componentData[newIndexData],
            componentData
          );
          this.setValidInput(componentData[newIndexData]);
        }
      }

      this.inputFormComponent[name] = [];
      for (let newIndexForm in form) {
        let componentData = form[newIndexForm].obj.componentData;
        let value = form[newIndexForm].value;
        let valid = form[newIndexForm].valid;
        for (let newIndexData in componentData) {
          let nameInput =
            name +
            "" +
            componentData[newIndexData].fristName +
            "" +
            newIndexForm;
          componentData[newIndexData].name = nameInput;
          this.setDataInput(
            value[newIndexData],
            componentData[newIndexData],
            componentData
          );
          this.setValidInput(componentData[newIndexData]);
        }
        this.inputFormComponent[name].push(form[newIndexForm].obj);
      }

      setTimeout(() => {
        this.renderForm = true;
      }, 1);
    },

    dateFomat(date) {
      let res = "";
      if (typeof date === "undefined" || date === null || date === "") {
        res = "-";
      } else {
        res = this.$moment(date).add(-7, "hour").format("DD MMMM Y h:mm a");
      }
      return res;
    },
    resetFilter() {
      this.$store.commit("setStartupList", this.allList);
      this.searchCompany = null;
      this.searchIndus = null;
      this.searchCompanyStatus = null;
      this.searchStaff = null;
    },
    filter() {
      var list = this.allList.filter(
        (search) =>
          ((this.searchCompany !== null &&
            (search.name
              .toLowerCase()
              .indexOf(this.searchCompany.toLowerCase()) > -1 ||
              search.organizeName
                .toLowerCase()
                .indexOf(this.searchCompany.toLowerCase()) > -1)) ||
            this.searchCompany === null) &&
          ((this.searchIndus !== null &&
            search.typeOfBusiness === this.searchIndus) ||
            this.searchIndus === null) &&
          ((this.searchCompanyStatus !== null &&
            Number(search.statusActive) === Number(this.searchCompanyStatus)) ||
            this.searchCompanyStatus === null) &&
          ((this.searchLastUpdated !== null &&
            this.$moment(search.dateUpdate).format("DD MMMM Y") ===
              this.$moment(this.searchLastUpdated).format("DD MMMM Y")) ||
            this.searchLastUpdated === null)
      );
      this.$store.commit("setStartupList", list);

      if (typeof this.$refs.dropdowntablet !== "undefined") {
        this.$refs.dropdowntablet.isActive = false;
      }
    },
    async backToFormList() {
      this.printIcon = false;
      this.tabPage = "list";
      this.organizeName = null;
      await this.fetchLoading();
      this.isViewComponent = false;
    },
    async goToDetail(input) {
      console.log("this.forms", this.forms);
      this.formsChildren = [];
      this.formsChildren.push(this.forms.components[0]);
      this.organizeLogo = input.organizeLogo;
      this.printIcon = true;
      this.stepIndex = 0;
      this.startupId = input.startUpId;
      this.organizeName = input.organizeName;
      this.asideMenu =
        this.forms.components.length > 0 ? this.forms.components[0].key : null;
      await this.fetchLoading();
      this.tabPage = "detail";
    },
    setViewComponent(status) {
      this.isViewComponent = status;
    },
    dateFomatPrint(date) {
      let res = "";
      if (typeof date === "undefined" || date === null || date === "") {
        res = "-";
      } else {
        res = moment(
          moment(date).add(-1, "days").locale("th", momentTH).add(543, "y")
        ).format("DD MMMM Y");
      }
      return res;
    },
  },
};
</script>
<style scoped>
.printPage {
  opacity: 0.6;
  bottom: 110px;
  right: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  border-radius: 100%;
  font-size: 25px;
  width: 70px;
  height: 70px;
  color: #fff;
  z-index: 10000;
  background: rgba(109, 141, 243, 0.9);
}
.printPage:hover {
  opacity: 1;
  background: #6d8df3;
  color: white;
}
.box-t-relative {
  position: relative;
  top: 65px;
  margin-left: 650px;
}
.box-t-relative-mobile {
  position: absolute;
  top: 170px;
}
.text-green {
  color: #00a79d;
  margin: 0px 60px;
}
.is-radius {
  border-radius: 7.5px;
}
.tb-report section {
  background-color: #fff;
  margin: 15px;
  border-radius: 5px;
}
.icon-unflex .icon {
  display: unset !important;
}
.min-w-152 {
  min-width: 125px;
}
.m-h-35 {
  min-height: 35px;
}
.borderPhoto {
  max-width: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.borderPhoto1 {
  border: 1px solid black;
  display: flex;
  justify-content: center;
  align-items: center;
}
.borderLogo {
  padding-left: 5px;
  max-width: 150px;
}
.flexend {
  display: flex;
  justify-content: flex-end;
  padding-right: 35px;
}
.pd-r-40 {
  padding-right: 80px;
  padding-top: 15px;
}
.marginLogo {
  margin: 25px 5px;
}
.border-bt {
  border-bottom: 1px solid black;
  margin: 10px;
}
.detailsHeader {
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 0 25px;
}
.centeralignment {
  display: flex;
  justify-content: center;
  text-align: center;
}
.flexDate {
  display: flex;
  flex-direction: column;
  text-align: left;
  justify-content: flex-end;
  width: 100%;
  margin-left: 5px;
}
.flexMg {
  display: flex;
  margin: 0 15px;
}
.back-filter {
  position: relative;
  top: 80px;
  right: 260px;
  z-index: 10;
}
.notForm {
  color: #ccc;
}
.box-percent {
  border: solid;
  border-radius: 7.5px;
  border-color: #00a79d;
  color: #00a79d;
  height: 70px;
  margin: 20px;
}
.box-percent:hover {
  border-color: #00a79d;
  color: #00a79d;
}
.percent {
  font-size: 1.2rem;
  font-family: "Mitr", sans-serif !important;
  font-weight: 500 !important;
}
.box-step {
  border-right: solid;
  border-right-width: 1px;
  border-color: #dbdbdb;
}
.ps-fixed {
  position: fixed !important;
  width: 39% !important;
}
</style>
